<template>
    <PageHeader :crumbs="[{ label: $t('portal.notifications.title') }]" />

    <div class="tw-p-2">
        <div class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
            <div class="tw-justify-between tw-flex tw-items-center tw-gap-2">
                <h2 class="tw-font-semibold tw-text-gray-700">{{ $t('portal.notifications.sent-title') }}</h2>
                <a-button left-icon="solar:plain-bold-duotone" @click="sendVisible = true">{{ $t('portal.notifications.send') }}</a-button>
            </div>

            <div class="tw-mt-5">
                <DataTable :columns="columns" :loading="loading" :count="items.length">
                    <tr v-for="n in items" :key="n.id" :class="rowClass">
                        <td :class="cellClass"><span class="tw-font-medium tw-text-gray-800">{{ n.title }}</span></td>
                        <td :class="cellClass"><span class="tw-text-gray-500 tw-block tw-max-w-[360px] tw-truncate">{{ n.message }}</span></td>
                        <td :class="cellClass"><span class="tw-inline-flex tw-items-center tw-gap-1 tw-text-gray-600"><icon icon="solar:users-group-rounded-bold-duotone" /> {{ n.recipients_count }}</span></td>
                        <td :class="cellClass"><span class="tw-text-gray-500 tw-whitespace-nowrap">{{ fmt.datetime(n.created_at) }}</span></td>
                    </tr>
                </DataTable>
            </div>

            <div class="tw-my-4"></div>

            <TablePagination v-if="items.length" :has-next="options.current_page < options.last_page"
                :has-previous="options.current_page > 1" @next="fetch(options.current_page + 1)"
                @previous="fetch(options.current_page - 1)" />
        </div>
    </div>

    <NotificationSendModal :visible="sendVisible" @cancel="sendVisible = false" @saved="onSent" />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { paginate } from '@/api/notifications';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/table/DataTable.vue';
import TablePagination from '@/components/table/TablePagination.vue';
import NotificationSendModal from './NotificationSendModal.vue';
import { useFormat } from '@/composables/useFormat';
import { rowClass, cellClass } from '@/composables/useTableStyles';

const i18n = useI18n();
const fmt = useFormat();

const columns = computed(() => [
    { label: i18n.t('portal.fields.title'), classes: ['tw-w-[220px]'] },
    { label: i18n.t('portal.fields.message') },
    { label: i18n.t('portal.fields.recipients'), classes: ['tw-w-[130px]'] },
    { label: i18n.t('fields.created_at'), classes: ['tw-w-[170px]'] },
]);

const items = ref([]);
const options = ref({ current_page: 1, last_page: 1 });
const loading = ref(false);
const sendVisible = ref(false);

async function fetch(page = 1) {
    loading.value = true;
    try {
        const { data } = await paginate({ per_page: 10, page });
        const { data: rows, ...ops } = data.data;
        items.value = rows;
        options.value = ops;
    } catch (e) { /* interceptor */ } finally {
        loading.value = false;
    }
}

const onSent = () => { sendVisible.value = false; fetch(1); };

fetch();
</script>
